/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Participant } from '../model/Participant';
import { environment } from '../../../environments/environment';

@Injectable()
export class MemberService {
  private url: string = environment.host + '/participant';

  constructor(private http: HttpClient) {}

  public getAllMembers() {
    return this.http.get(this.url.toString()).toPromise();
  }

  public getAllMembers_updated(page: any, size: any) {
    const queryParams = '?page=' + (page || 0) + '&size=' + (size || 0);
    return this.http.get(this.url.toString() + queryParams).toPromise();
  }

  public createMember(member: Participant) {
    return this.http.post(this.url.toString(), member).toPromise();
  }

  public createESMember(member: Participant) {
    const url = environment.host + '/es/participant';
    return this.http.post(url, member).toPromise();
  }

  public getAllCountries() {
    return this.http.get(this.url.toString() + '/metadata').toPromise();
  }

  public updatePariticipantAddress(participantPayLoad: any, clientId: any) {
    return this.http.put(this.url.toString() + '/' + clientId, participantPayLoad).toPromise();
  }
}
